import Tab from './Tab';
import getVisibleTabs from '../utils/getVisibleTabs';
import { observer } from 'mobx-react';
import ensurePrimaryReadingPaneTabHandler from 'owa-mail-reading-pane-store/lib/utils/primaryReadingPaneTabHandler';
import { lazySubscribeToResizeEvent, lazyUnsubscribeFromResizeEvent } from 'owa-resize-event';
import setTabBarWidth from 'owa-tab-store/lib/actions/setTabBarWidth';
import { getStore } from 'owa-tab-store/lib/store/tabStore';
import * as React from 'react';

const styles = require('./TabBar.scss');
const classNames = require('classnames/bind').bind(styles);

@observer
export default class TabBar extends React.Component<{}, {}> {
    private div: HTMLDivElement;

    componentDidMount() {
        lazySubscribeToResizeEvent.importAndExecute(this.onResize);
        this.onResize();
    }

    componentWillUnmount() {
        lazyUnsubscribeFromResizeEvent.importAndExecute(this.onResize);
    }

    render() {
        ensurePrimaryReadingPaneTabHandler();
        const { visibleTabs, shouldShrinkActiveChatTabs } = getVisibleTabs();
        return (
            <div
                className={classNames(styles.tabBar, {
                    shrinkChatTabs: shouldShrinkActiveChatTabs,
                })}
                ref={ref => (this.div = ref)}>
                {visibleTabs.map(tab => (
                    <Tab key={tab.id} viewState={tab} />
                ))}
            </div>
        );
    }

    private onResize = () => {
        if (this.div) {
            const width = this.div.clientWidth;
            if (width > 0) {
                if (width != getStore().tabBarWidth) {
                    setTabBarWidth(width);
                }
            }
        }
    };
}
